var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.2,
    height: 31.1,
    viewBox: "0 0 85.2 31.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1",
    "data-name": "Rect\\xE1ngulo 1",
    width: 85.2,
    height: 31.1,
    transform: "translate(0 0.597)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(0 -0.597)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M84.1,12c-4.6,0-7-2.5-9.1-4.8C72.9,5,71.2,3.1,67.5,3.1S62,5,60,7.2C57.9,9.4,55.5,12,50.9,12s-7-2.5-9.1-4.8C39.7,5,38,3.1,34.3,3.1S28.8,5,26.8,7.2C24.7,9.4,22.3,12,17.7,12s-7-2.5-9.1-4.8C6.6,5,4.8,3.1,1.1,3.1A1.135,1.135,0,0,1,0,1.9,1.23,1.23,0,0,1,1.1.6c4.6,0,7,2.5,9.1,4.8,2,2.2,3.8,4.1,7.5,4.1s5.5-1.9,7.5-4.1C27.3,3.1,29.7.6,34.3.6s7,2.5,9.1,4.8c2.1,2.2,3.8,4.1,7.5,4.1s5.5-1.9,7.5-4.1C60.5,3.1,62.9.6,67.5.6s7,2.5,9.1,4.8c2.1,2.2,3.8,4.1,7.5,4.1a1.23,1.23,0,0,1,1.1,1.3A1.2,1.2,0,0,1,84.1,12Z",
    fill: "#db578a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M84.1,31.7c-4.6,0-7-2.5-9.1-4.8-2.1-2.2-3.8-4.1-7.5-4.1S62,24.7,60,26.9c-2.1,2.2-4.5,4.8-9.1,4.8s-7-2.5-9.1-4.8c-2.1-2.2-3.8-4.1-7.5-4.1s-5.5,1.9-7.5,4.1c-2.1,2.2-4.5,4.8-9.1,4.8s-7-2.5-9.1-4.8c-2.1-2.2-3.8-4.1-7.5-4.1-.6.1-1.1-.5-1.1-1.2a1.23,1.23,0,0,1,1.1-1.3c4.6,0,7,2.5,9.1,4.8,2.1,2.2,3.8,4.1,7.5,4.1s5.5-1.9,7.5-4.1c2.1-2.2,4.5-4.8,9.1-4.8s7,2.5,9.1,4.8c2.1,2.2,3.8,4.1,7.5,4.1s5.5-1.9,7.5-4.1c2.1-2.2,4.5-4.8,9.1-4.8s7,2.5,9.1,4.8c2.1,2.2,3.8,4.1,7.5,4.1a1.23,1.23,0,0,1,1.1,1.3A1.135,1.135,0,0,1,84.1,31.7Z",
    fill: "#02a2a2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.e61517405f0d52564fa1f019a0d8c0b8.svg";
export { ForwardRef as ReactComponent };